<script setup lang="ts">
const route = useRoute();

await navigateTo(
  { path: '/vip/missions', query: route.query },
  { replace: true, redirectCode: 301 },
);
</script>

<template>
  <div></div>
</template>
